import {
  Box, Grid, makeStyles, Typography, Hidden,
} from '@material-ui/core';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import states from '../../modules/states';
import QuestionHeaderBox from '../QuestionHeaderBox';

function Q3Header() {
  const { stateCode } = useParams();
  const { primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    root: {
      marginTop: theme.spacing(4),
    },
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    definitionBox: {
      padding: theme.spacing(2),
      backgroundColor: `${primaryColor} !important`,
      color: '#fff !important',
    },
    questionBox: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    headline: {
      fontWeight: 'bold',
    },
  }))();

  return (
    <Grid
      container
      className={classes.root}
      direction="row"
      justify="center"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <QuestionHeaderBox color={primaryColor}>
          <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
            In {states[stateCode.toUpperCase()]}, do families have access to non-standard hours (NSH) child care?
          </Typography>
          <Hidden only="xs">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={3}>
                <Box borderRadius={8} className={classes.definitionBox}>
                  <Typography variant="h5" align="center">Access</Typography>

                  <AccessibilityIcon style={{ fontSize: 40, color: '#fff' }} />
                </Box>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body1">% of licensed providers that offer NSH care</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={3}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center" style={{ marginTop: '-5px' }}>
                      # licensed providers that offer NSH care
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <hr style={{ border: `2px solid ${primaryColor}` }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center">all licensed providers</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Typography variant="body1" align="center" style={{ color: primaryColor }}>
              Access can be understood by looking at the number of licensed providers that offer NSH care as a percentage of all licensed providers.
            </Typography>
          </Hidden>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            Increasingly, U.S. parents are working non-standard hours (NSH) (i.e., between 6 p.m. and 6 a.m. and/or on weekends).
            The percentage of licensed child care programs that provide care during NSH doesn&apos;t meet the demand.
            Use the graphics to explore access to NSH child care in {states[stateCode.toUpperCase()]}.
          </Typography>
        </QuestionHeaderBox>
      </Grid>
    </Grid>
  );
}

export default Q3Header;
